module.exports = __webpack_public_path__ + "static/leonin-1-ce7fba5f9083da878e9dcec694e71cd8.png";